// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MgqQVJv0YQQ622ICknkh{line-height:18px}", "",{"version":3,"sources":["webpack://./src/components/ContestHeader-classes.module.scss"],"names":[],"mappings":"AAAA,sBACE,gBAAA","sourcesContent":[".tagline {\n\t\tline-height: 18px;\n\t}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagline": "MgqQVJv0YQQ622ICknkh"
};
export default ___CSS_LOADER_EXPORT___;
